import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _forEach from 'lodash/forEach';
import _reduce from 'lodash/reduce';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Material UI
import grey from '@material-ui/core/colors/grey';
// Models
import mDevice from 'models/device';
import mDeviceSlave from 'models/deviceSlave';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import { joinNonEmpty } from 'utils/Tools';
import AppIcon from 'components/icons/AppIcon';
import { CloseIconButton } from 'components/buttons/IconButtons';

const triggerDesc = (trigger, intl) => {
  const { equipment } = trigger;
  const pText = equipment ? equipment.name : intl.formatMessage({ id: 'info.deviceSlaveTrigger' }, { triggerType: trigger.type });

  // Check if an IP address must be displayed
  const { type: ethernetType } = mDevice.virtualTriggerEthernet;
  let ipAddress = '';
  if (equipment && trigger.type === ethernetType) {
    ipAddress = equipment.ip;
  }

  const sText = mDevice.triggerCanHaveEquipement(trigger) ? ` (${intl.formatMessage({ id: 'info.deviceSlaveTriggerEquipment' }, { triggerType: trigger.type, ipAddress })})` : '';

  return `${pText}${sText}`;
};

const TriggerSelectFieldFilter = ({ triggerId, devices, onChange }) => {
  const intl = useIntl();
  const sortedDevices = mDevice.sortElements(devices, ['installation.device.name']);
  const allTriggers = _reduce(sortedDevices, (result, device) => {
    // Device label
    const deviceName = mDevice.installationName(device);
    // Get device slaves
    const slaves = mDevice.sortSlaves(device.device_slaves);
    // Parse slaves
    _forEach(slaves, (slave) => {
      // Create a header for this device slave
      result.push({
        key: _toString(`deviceSlave_${slave.id}`),
        header: true,
        label: joinNonEmpty([deviceName, intl.formatMessage({ id: 'title.deviceSlave' }, { isMotherboard: mDeviceSlave.isMotherboard(slave), desc: slave.name })], ' - '),
      });
      // Build visible triggers of this device slave
      const triggers = _reduce(mDevice.sortTriggers(slave.triggers), (res, trigger) => {
        // Only display trigger that can't have equipments or
        // triggers that are actually connected to an equipment
        if (!mDevice.triggerCanHaveEquipement(trigger) || trigger.equipment) {
          res.push({
            key: _toString(trigger.id),
            value: trigger.id,
            label: triggerDesc(trigger, intl),
            icon: <AppIcon id={mDevice.triggerIcon(trigger)} color={grey[700]} />,
          });
        }

        return res;
      }, []);
      // Add triggers to final result
      _forEach(triggers, (trigger) => {
        result.push(trigger);
      });
      return result;
    });

    return result;
  }, []);

  const handleChange = (value) => {
    if (value !== '_ignore') {
      onChange(value);
    }
  };

  return (
    <Select
      label={<LocalizedMessage id="field.trigger" />}
      value={triggerId}
      items={allTriggers}
      withNullItem
      hideDropDownIcon={triggerId !== null}
      adornments={{
        end: triggerId !== null ? (
          <CloseIconButton onClick={() => onChange(null)} tooltipId="tooltip.empty" />
        ) : null,
      }}
      onChange={handleChange}
    />
  );
};

TriggerSelectFieldFilter.propTypes = {
  triggerId: PropTypes.number,
  devices: PropTypes.arrayOf(deviceDataShape).isRequired,
  onChange: PropTypes.func.isRequired,
};

TriggerSelectFieldFilter.defaultProps = {
  triggerId: null,
};

const mapStateToProps = (state) => ({
  devices: state.deviceData.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(TriggerSelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/TriggerSelectFieldFilter.js